import Dexie from 'dexie'

export const dataBase = new Dexie('MerchClientDB')

dataBase.version(1).stores({
  projects:    'id, cachedAt',
  networks:    'id, projectId, cachedAt',
  points:      'id, projectId, networkId, [networkId+projectId], cachedAt',
  products:    '[id+pointId+categoryId], id, name, pointId, categoryId, [categoryId+pointId], cachedAt',
  categories:  '[id+pointId], id, name, pointId, cachedAt',
  countActionsProduct: 'id, pointId, count, cachedAt',
  productReportData: 'id, productId, pointId, [productId+pointId], synced, cachedAt',
  pointReport: '++id, serverId, pointId, projectId, synced, updatedAt',
  photos:      '++id, reportId, serverId, synced, dmp',

  motivationalReport: 'id,  projectid, networkId, pointId, cachedAt',
  motivationalDmp: '++id, dmpCategory, comment, motivationalReportId, synced, serverId, cachedAt',
  motivationalDmpReport: '++id, localDmpId, dmpCategory, synced, cachedAt',
  dmpCategories: 'title, cachedAt'
})

export default dataBase